import { createSlice } from '@reduxjs/toolkit';

import { handleAdminSearchSupplements } from './actions';
import { IAdminSupplementSearchState } from './slice.interface';

const initialState: IAdminSupplementSearchState = {
  data: null,
  isLoading: false,
};

export const supplementSearchSlice = createSlice({
  name: 'admin-supplement-search',
  initialState,
  reducers: {
    removeAdminSupplementSearch: state => {
      state.data = null;
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleAdminSearchSupplements.pending, (state: IAdminSupplementSearchState) => {
        state.isLoading = true;
      })
      .addCase(
        handleAdminSearchSupplements.fulfilled,
        (state: IAdminSupplementSearchState, action) => {
          const { page, pageCount } = action.payload.data.pagination;

          if (pageCount === 1 || page === 1) {
            state.data = action.payload.data;
          } else {
            state.data = {
              ...action.payload.data,
              tableData: [...(state.data?.tableData ?? []), ...action.payload.data.tableData],
            };
          }

          state.isLoading = false;
        },
      );
  },
});

export const { removeAdminSupplementSearch } = supplementSearchSlice.actions;

export default supplementSearchSlice.reducer;
